import {
    ActionTypes,
    IPopMenuItemAction,
    IPushMenuItemAction,
    IToggleSidebarAction
} from './types';

export function toggleSidebar(): IToggleSidebarAction {
    return { type: ActionTypes.TOGGLE_SIDEBAR };
}

export function pushMenuItem(item: number): IPushMenuItemAction {
    return { type: ActionTypes.PUSH_MENU_ITEM, payload: { item } };
}

export function popMenuItem(): IPopMenuItemAction {
    return { type: ActionTypes.POP_MENU_ITEM };
}
